enum eventTypes {
  navEvent = 'nav',
  ctaEvent = 'cta',
}

export default eventTypes;
